<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <g transform="translate(-1300 -30)">
            <circle class="a" cx="19" cy="19" r="19" transform="translate(1300 30)" fill="#a5d867"/>
            <g class="b" transform="translate(1311 41)" fill="none" stroke="#383935" stroke-width="2px">
                <circle class="c" cx="8" cy="8" r="8" stroke="none"/>
                <circle class="d" cx="8" cy="8" r="7" fill="none"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'MenuIcon'
}
</script>

<style scoped>
    svg {
        width:38px;
        height: 38px;
    }
</style>